module.exports = __webpack_public_path__ + "static/img/8.2915b0e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/zh/8.png
// module id = VaNl
// module chunks = 0